import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_REVIEW_CONTRACTORS_WITH_CONTENT_TYPES = "GET_REVIEW_CONTRACTORS_WITH_CONTENT_TYPES";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ContentTypes/GetReviewContractorsWithContentTypes`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mock = () => Promise.resolve([]);

register(GET_REVIEW_CONTRACTORS_WITH_CONTENT_TYPES, service, mock);
